(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // El A/B test finalizó: el carrito propio (antigua variante B) es ahora la
  // única variante, así que el drawer arranca siempre. Se mantiene idempotente
  // por si `maybeInit` se invoca más de una vez.
  var inited = false;
  function maybeInit() {
    if (inited) return;
    inited = true;
    ready(initDrawer);
  }

  function initDrawer() {
    var drawer      = document.getElementById('CartDrawerCustom');
    if (!drawer) return;

    // Textos traducibles inyectados desde theme.liquid (theme.strings.cartDrawer).
    // Si por algún motivo no están, cada uso cae en el literal español original.
    var STR = (window.theme && window.theme.strings && window.theme.strings.cartDrawer) || {};

    // Prefijo de idioma para todos los fetch de datos de producto. theme.routes.home
    // es routes.root_url: '' en el idioma primario, '/en' (etc.) en los demás. Sin
    // este prefijo los endpoints (/cart.js, /products, /recommendations) devuelven
    // SIEMPRE el idioma primario (español), aunque el storefront esté en inglés.
    var ROOT = ((window.theme && window.theme.routes && window.theme.routes.home) || '/').replace(/\/+$/, '');

    var overlay     = drawer.querySelector('[data-hsc-overlay]');
    var panel       = drawer.querySelector('.hsc-drawer__panel');
    var bodyEl      = drawer.querySelector('[data-hsc-body]');
    var itemsEl     = drawer.querySelector('[data-hsc-items]');
    var upsellsEl   = drawer.querySelector('[data-hsc-upsells]');
    var totalLabelEl   = drawer.querySelector('[data-hsc-total-label]');
    var totalValueEl   = drawer.querySelector('[data-hsc-total-value]');
    var totalToggleEl  = drawer.querySelector('[data-hsc-total-toggle]');
    var breakdownEl    = drawer.querySelector('[data-hsc-breakdown]');
    var breakdownSubEl = drawer.querySelector('[data-hsc-breakdown-subtotal]');
    var promoRowEl     = drawer.querySelector('[data-hsc-promo-row]');
    var promoValueEl   = drawer.querySelector('[data-hsc-promo-value]');
    var couponRowEl    = drawer.querySelector('[data-hsc-coupon-row]');
    var couponValueEl  = drawer.querySelector('[data-hsc-coupon-value]');
    var tierEl      = drawer.querySelector('[data-hsc-tier]');
    var emptyEl     = drawer.querySelector('[data-hsc-empty]');
    var footerEl    = drawer.querySelector('[data-hsc-footer]');
    var noteEl      = drawer.querySelector('[data-hsc-note]');
    var checkoutBtn = drawer.querySelector('[data-hsc-checkout]');
    var savingsTextEl = drawer.querySelector('[data-hsc-savings-text]');

    var isOpen    = false;
    var noteTimer = null;

    // ── Money formatter ──────────────────────────────────────────────
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts  = amount.split('.');
      parts[0]   = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$\u00a0' + parts.join('.');
    }

    // ── Escape HTML ──────────────────────────────────────────────────
    function esc(s) {
      if (typeof s !== 'string') return '';
      return s.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // ── Shopify CDN image resize ─────────────────────────────────────
    function resizeImg(src, size) {
      if (!src || typeof src !== 'string') return '';
      return src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$3');
    }

    // ── Fetch cart JSON ──────────────────────────────────────────────
    function fetchCart() {
      // theme.routes.cart ya incluye el prefijo de idioma y el .js (ver theme.liquid).
      var url = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    // ── Info de producto (tags + compare_at por variante) ────────────
    // cart.js NO incluye las tags del producto. Para saber si un producto
    // está "en promoción" replicamos la regla del theme: requiere la tag
    // "sale" (compare_at_price por sí solo NO basta, porque se usa también
    // para otros fines como el precio estimado/tiers). Se lee de
    // /products/<handle>.js, con caché por handle para no repetir requests.
    var productInfoCache = {};

    function fetchProductInfo(handle) {
      if (!handle) return Promise.resolve(null);
      if (productInfoCache[handle]) return Promise.resolve(productInfoCache[handle]);
      return fetch(ROOT + '/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var info = { onSale: false, isPreorder: false, variants: {} };
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          info.onSale     = tags.indexOf('sale') !== -1;
          info.isPreorder = tags.indexOf('pre-order') !== -1;
          (p.variants || []).forEach(function (v) {
            info.variants[v.id] = { price: v.price, compareAt: v.compare_at_price, available: v.available };
          });
          productInfoCache[handle] = info;
          return info;
        })
        .catch(function () {
          productInfoCache[handle] = { onSale: false, isPreorder: false, variants: {} };
          return productInfoCache[handle];
        });
    }

    // Garantiza que todas las tags/compare_at de los items del carrito
    // estén en caché antes de renderizar (resuelve aunque alguno falle).
    function ensureSaleInfo(cart) {
      var handles = {};
      (cart.items || []).forEach(function (it) { if (it.handle) handles[it.handle] = true; });
      return Promise.all(Object.keys(handles).map(fetchProductInfo));
    }

    // Devuelve el compare_at por unidad SOLO si el producto está en promo
    // (tiene la tag "sale") y el compare_at es mayor al precio final.
    function saleCompareUnit(item) {
      var info = productInfoCache[item.handle];
      if (!info || !info.onSale) return 0;
      var v = info.variants[item.variant_id];
      var compareUnit = (v && v.compareAt) || item.compare_at_price || 0;
      return compareUnit > item.final_price ? compareUnit : 0;
    }

    // ¿El producto es pre-order? (tag "pre-order", igual que el theme)
    function isPreorder(item) {
      var info = productInfoCache[item.handle];
      return !!(info && info.isPreorder);
    }

    // ¿La línea está agotada? La clienta pudo agregar la talla y que se
    // acabara antes de comprar. Shopify deja la línea en el carrito pero
    // marca la variante como no disponible (a veces con quantity/price 0).
    // Señal autoritativa: variant.available === false del endpoint .js;
    // fallback: quantity <= 0 (por si la info de producto no cargó).
    function isSoldOut(item) {
      var info = productInfoCache[item.handle];
      var v = info && info.variants[item.variant_id];
      if (v && v.available === false) return true;
      if (!item.quantity || item.quantity <= 0) return true;
      return false;
    }

    // ── Persistencia de items vistos (para "fantasmas" agotados) ─────
    // Shopify elimina del carrito las líneas cuya variante se agota; al
    // volver, ya no vienen en cart.js. Para que la línea agotada siga
    // visible "hasta que la clienta la elimine", recordamos en localStorage
    // los items que han estado en el carrito (datos mínimos para pintarlos)
    // y, si desaparecen del carrito pero su variante sigue sin stock, los
    // reconstruimos como "fantasma" (solo imagen, título, pill Agotado y
    // botón de eliminar; sin precio ni controles de cantidad).
    var SEEN_KEY = 'hs_cart_seen_v1';

    function loadSeen() {
      try { return JSON.parse(localStorage.getItem(SEEN_KEY)) || {}; }
      catch (e) { return {}; }
    }
    function saveSeen(map) {
      try { localStorage.setItem(SEEN_KEY, JSON.stringify(map)); } catch (e) {}
    }

    // Refresca el snapshot con los items actuales del carrito y devuelve los
    // candidatos a "fantasma": variantes recordadas que ya no están en el
    // carrito (el filtro final por stock se hace tras cargar product info).
    function syncSeenAndGetGhosts(cart) {
      var seen = loadSeen();
      var inCart = {};
      (cart.items || []).forEach(function (it) {
        inCart[it.variant_id] = true;
        seen[it.variant_id] = {
          variant_id:    it.variant_id,
          handle:        it.handle,
          url:           it.url,
          title:         it.product_title,
          variant_title: it.variant_title,
          image:         (it.featured_image && it.featured_image.url) || ''
        };
      });
      saveSeen(seen);
      var ghosts = [];
      Object.keys(seen).forEach(function (vid) {
        if (!inCart[vid]) ghosts.push(seen[vid]);
      });
      return ghosts;
    }

    function removeFromSeen(variantId) {
      if (variantId == null) return;
      var seen = loadSeen();
      if (seen[variantId]) { delete seen[variantId]; saveSeen(seen); }
    }

    var lastCart     = null; // último carrito renderizado (para re-render local)
    var keyToVariant = {};   // line key -> variant_id (para limpiar snapshot)

    // SVG del bote de basura (reutilizado en items reales y fantasmas).
    var TRASH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'
      + '<polyline points="3 6 5 6 21 6"/>'
      + '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>'
      + '<path d="M10 11v6"/><path d="M14 11v6"/>'
      + '<path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>'
      + '</svg>';

    // ── Update header bubble ─────────────────────────────────────────
    function updateBubble(count) {
      document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
        el.innerText = count;
      });
      document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
        if (count > 0) b.classList.add('cart-link__bubble--visible');
        else           b.classList.remove('cart-link__bubble--visible');
      });
    }

    // ── Tier progress bar ────────────────────────────────────────────
    // SVG de bolsa para los marcadores de cada tier.
    var TIER_BAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"'
      + ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>'
      + '<line x1="3" y1="6" x2="21" y2="6"/>'
      + '<path d="M16 10a4 4 0 0 1-8 0"/></svg>';

    // SVG de check para los marcadores ya alcanzados.
    var TIER_CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"'
      + ' stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M20 6 9 17l-5-5"/></svg>';

    function renderTier(cart) {
      if (!tierEl) return;
      if (typeof discountTiers !== 'function') { tierEl.innerHTML = ''; tierEl.hidden = true; return; }

      var t = discountTiers();
      var TIERS = [
        { threshold: t.tierOne.threshold,   pct: t.tierOne.discountPct },
        { threshold: t.tierTwo.threshold,   pct: t.tierTwo.discountPct },
        { threshold: t.tierThree.threshold, pct: t.tierThree.discountPct }
      ];
      var code = t.discountCode;

      // Total pre-descuento (el cupón ya viene aplicado en cart.js; aquí
      // usamos el precio base para decidir el tier sin doble descuento).
      var total = cart.items.reduce(function (sum, item) {
        var base = (item.compare_at_price && item.compare_at_price > item.original_price)
          ? item.compare_at_price : item.original_price;
        return sum + base * item.quantity;
      }, 0) / 100;

      var activeTier = -1;
      for (var i = TIERS.length - 1; i >= 0; i--) {
        if (total >= TIERS[i].threshold) { activeTier = i; break; }
      }
      var nextTier = activeTier < TIERS.length - 1 ? activeTier + 1 : -1;
      var fmt = function (n) { return n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

      // ── Fill alineado a los centros de los marcadores ──
      // Los marcadores (flex:1) quedan centrados en cada tercio de la barra,
      // o sea en 1/6, 3/6 y 5/6 del ancho. El fill debe llegar exactamente a
      // esos puntos cuando se alcanza cada tier para no rebasarlos antes.
      var M1 = 100 / 6, M2 = 50, M3 = 500 / 6;
      var fill;
      if (total < TIERS[0].threshold) {
        fill = (total / TIERS[0].threshold) * M1;
      } else if (total < TIERS[1].threshold) {
        fill = M1 + (total - TIERS[0].threshold) / (TIERS[1].threshold - TIERS[0].threshold) * (M2 - M1);
      } else if (total < TIERS[2].threshold) {
        fill = M2 + (total - TIERS[1].threshold) / (TIERS[2].threshold - TIERS[1].threshold) * (M3 - M2);
      } else {
        fill = 100;
      }
      fill = Math.max(0, Math.min(100, fill));

      // ── Marcadores (bolsa + % + monto) ──
      var markersHtml = TIERS.map(function (tier) {
        var reached = total >= tier.threshold;
        return '<div class="hsc-tier-bar__marker' + (reached ? ' hsc-tier-bar__marker--reached' : '') + '">'
          + '<span class="hsc-tier-bar__marker-icon">' + (reached ? TIER_CHECK_SVG : TIER_BAG_SVG) + '</span>'
          + '<span class="hsc-tier-bar__marker-pct">' + tier.pct + '%</span>'
          + '</div>';
      }).join('');

      // ── Texto de estado (monto faltante + % por alcanzar) ──
      var tierProgressTpl = STR.tierProgress
        || 'Agrega <strong class="is-accent">[amount]</strong> para obtener un descuento del <strong>[pct]%</strong>';
      var tierReachedTpl = STR.tierReached
        || '¡Ya alcanzaste el descuento del <strong>[pct]%</strong>!';
      function tierProgressHtml(amountNum, pct) {
        return tierProgressTpl
          .replace('[amount]', '$' + fmt(amountNum))
          .replace('[pct]', pct);
      }

      var statusHtml;
      if (activeTier === -1) {
        statusHtml = tierProgressHtml(TIERS[0].threshold - total, TIERS[0].pct);
      } else if (nextTier !== -1) {
        statusHtml = tierProgressHtml(TIERS[nextTier].threshold - total, TIERS[nextTier].pct);
      } else {
        statusHtml = tierReachedTpl.replace('[pct]', TIERS[TIERS.length - 1].pct);
      }

      // Construye la estructura una sola vez; en renders posteriores solo
      // actualiza contenidos y el width del fill, para que la transición CSS
      // se dispare cuando el carrito cambia (agregar/quitar producto).
      var markersEl = tierEl.querySelector('.hsc-tier-bar__markers');
      var fillEl    = tierEl.querySelector('.hsc-tier-bar__fill');
      var statusEl  = tierEl.querySelector('.hsc-tier-bar__status');

      if (!markersEl || !fillEl || !statusEl) {
        tierEl.innerHTML = '<div class="hsc-tier-bar__markers"></div>'
          + '<div class="hsc-tier-bar__track"><div class="hsc-tier-bar__fill"></div></div>'
          + '<div class="hsc-tier-bar__status"></div>';
        markersEl = tierEl.querySelector('.hsc-tier-bar__markers');
        fillEl    = tierEl.querySelector('.hsc-tier-bar__fill');
        statusEl  = tierEl.querySelector('.hsc-tier-bar__status');
      }

      markersEl.innerHTML = markersHtml;
      statusEl.innerHTML  = statusHtml;
      fillEl.style.width  = fill.toFixed(2) + '%';
      tierEl.hidden = false;
    }

    // ── Total + desglose (Subtotal / Cupón) ─────────────────────────
    // El colapso/expansión se controla SOLO con la clase --open (el estado
    // colapsado es max-height:0 vía CSS). No se usa el atributo `hidden`
    // porque display:none cortaría la transición.
    function collapseBreakdown() {
      if (!breakdownEl || !totalToggleEl) return;
      breakdownEl.classList.remove('hsc-total__breakdown--open');
      totalToggleEl.setAttribute('aria-expanded', 'false');
    }

    function toggleBreakdown() {
      if (!breakdownEl || !totalToggleEl) return;
      // No-op si no hay descuento (la flecha está oculta).
      if (!totalToggleEl.classList.contains('hsc-total__trigger--has-breakdown')) return;
      var willOpen = !breakdownEl.classList.contains('hsc-total__breakdown--open');
      breakdownEl.classList.toggle('hsc-total__breakdown--open', willOpen);
      totalToggleEl.setAttribute('aria-expanded', String(willOpen));
    }

    // ── Ahorro bajo el total ("cierre" del carrito) ─────────────────
    // Versión ganadora del A/B de Intelligems, ahora fija. Recibe las MISMAS cifras del desglose
    // (Valor del pedido y Total), así que siempre cuadra con él:
    // ahorro = rebaja + descuentos. Solo se escribe cuando llega el carrito
    // nuevo (conserva el valor anterior mientras tanto, sin parpadeo).
    var SAVINGS_MIN_CENTS = 10000; // < $100.00 no se muestra
    var SAVINGS_MIN_PCT   = 10;    // el (Y%) solo si es >= 10

    function renderSavings(orderValue, total) {
      if (!savingsTextEl) return;
      var saved = orderValue - total;
      if (orderValue <= 0 || saved < SAVINGS_MIN_CENTS) { hideSavings(); return; }
      // Enteros en centavos: evita que el redondeo flotante baje un punto.
      var pct = Math.floor(saved * 100 / orderValue);
      var tpl = pct >= SAVINGS_MIN_PCT
        ? (STR.savingsPct || 'Ahorras [amount] ([pct]%)')
        : (STR.savings || 'Ahorras [amount]');
      savingsTextEl.textContent = tpl.replace('[amount]', formatMoney(saved)).replace('[pct]', pct);
      savingsTextEl.hidden = false;
    }

    // Si falla la actualización del carrito no hay cifra confiable: se oculta
    // hasta el siguiente render exitoso.
    function hideSavings() {
      if (savingsTextEl) savingsTextEl.hidden = true;
    }

    // ── Render cart items ────────────────────────────────────────────
    function renderItems(cart, ghosts) {
      if (!itemsEl) return;
      ghosts = ghosts || [];

      // "Comprables": líneas del carrito que NO están agotadas. Determinan
      // si se muestra el footer (Total + checkout).
      var hasPurchasable = cart.items.some(function (it) { return !isSoldOut(it); });
      // Hay algo que mostrar si queda cualquier línea (incluidas las agotadas
      // que Shopify mantiene en el carrito, aunque sea con quantity 0) o algún
      // fantasma. Un producto agotado que es el único del carrito debe seguir
      // mostrándose, no caer al estado vacío.
      var hasAnyLine = cart.items.length > 0;
      var hasGhost   = ghosts.length > 0;

      // Vacío real: sin líneas y sin fantasmas → estado vacío. Los upsells
      // NO se ocultan aquí: loadUpsells los muestra igual (con la colección
      // de respaldo) para que sigan visibles con el carrito vacío.
      if (!hasAnyLine && !hasGhost) {
        itemsEl.innerHTML = '';
        if (emptyEl)  emptyEl.hidden  = false;
        if (footerEl) footerEl.hidden = true;
        return;
      }

      if (emptyEl)  emptyEl.hidden  = true;
      // El footer (Total + checkout) solo tiene sentido si hay algo comprable;
      // si únicamente quedan agotados o fantasmas, se oculta.
      if (footerEl) footerEl.hidden = !hasPurchasable;

      // Mapa key->variant para limpiar el snapshot al eliminar una línea.
      keyToVariant = {};
      cart.items.forEach(function (it) { keyToVariant[it.key] = it.variant_id; });

      // Los productos agotados se mueven SIEMPRE al final del carrito
      // (conservando el orden relativo de cada grupo). Así las clientas ven
      // primero lo que sí pueden comprar y los agotados quedan abajo, justo
      // antes de los "fantasmas" (que también van al final).
      var sortedItems = cart.items.slice().sort(function (a, b) {
        return (isSoldOut(a) ? 1 : 0) - (isSoldOut(b) ? 1 : 0);
      });

      var html = sortedItems.map(function (item) {
        // Línea agotada: se mantiene visible pero sin precio ni controles
        // de cantidad (solo el botón de eliminar y el pill "Agotado").
        var soldOut = isSoldOut(item);

        // compareUnit > 0 solo si el producto tiene la tag "sale" y su
        // compare_at supera al precio final (ver saleCompareUnit).
        var compareUnit = saleCompareUnit(item);
        var hasCompare  = compareUnit > 0;

        var priceHtml = hasCompare
          ? '<span class="hsc-item__compare">' + formatMoney(compareUnit) + '</span>'
            + '<span class="hsc-item__price hsc-item__price--sale">' + formatMoney(item.final_price) + '</span>'
          : '<span class="hsc-item__price">' + formatMoney(item.final_price) + '</span>';

        var imgSrc = item.featured_image && item.featured_image.url
          ? resizeImg(item.featured_image.url, 300) : '';

        var imgHtml = imgSrc
          ? '<img src="' + esc(imgSrc) + '" alt="' + esc(item.product_title) + '" loading="lazy" decoding="async">'
          : '';

        var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="hsc-item__variant">' + esc(item.variant_title) + '</div>' : '';

        var preorderPill = isPreorder(item)
          ? '<span class="hsc-item__preorder">' + esc(STR.preorder || 'Pre-order') + '</span>' : '';

        // Pill "Sale" para productos en oferta (tag "sale" con rebaja real).
        var salePill = hasCompare
          ? '<span class="hsc-item__sale">' + esc(STR.discount || 'Rebaja') + '</span>' : '';

        // Pill "Ahorras" comentado temporalmente.
        var savingPill = '';
        // if (hasCompare) {
        //   var saved = (compareUnit - item.final_price) * item.quantity;
        //   savingPill = '<div class="hsc-item__saving">Ahorras ' + formatMoney(saved) + '</div>';
        // }

        // Total de línea. Se tacha el precio "antes" en dos casos:
        //  (a) Cupón / descuento de carrito: final_line_price < original_line_price
        //      (el cupón YA viene aplicado por Shopify en cart.js).
        //  (b) Producto en promoción (tag "sale"): el "antes" es
        //      compareUnit * cantidad, aunque no haya cupón.
        // El precio tachado es la referencia más alta disponible.
        var lineFinal      = item.final_line_price;
        var lineOriginal   = item.original_line_price;
        var lineCompareRef = hasCompare
          ? compareUnit * item.quantity
          : lineOriginal;
        var totalHtml;
        if (lineCompareRef > lineFinal) {
          totalHtml = '<div class="hsc-item__total-wrap">'
            + '<span class="hsc-item__total hsc-item__total--discount">' + formatMoney(lineFinal) + '</span>'
            + '<span class="hsc-item__total-compare">' + formatMoney(lineCompareRef) + '</span>'
            + '</div>';
        } else {
          totalHtml = '<span class="hsc-item__total">' + formatMoney(lineFinal) + '</span>';
        }

        // Etiqueta del código de descuento aplicado (nombre real desde
        // cart.js, no hardcodeado). Solo si hay descuento en la línea.
        var discountLabel = '';
        if (lineOriginal > lineFinal) {
          var dTitle = '';
          if (item.discounts && item.discounts[0] && item.discounts[0].title) {
            dTitle = item.discounts[0].title;
          } else if (item.line_level_discount_allocations
              && item.line_level_discount_allocations[0]
              && item.line_level_discount_allocations[0].discount_application) {
            dTitle = item.line_level_discount_allocations[0].discount_application.title;
          }
          if (dTitle) {
            discountLabel = '<span class="hsc-item__discount">' + esc(dTitle) + '</span>';
          }
        }

        // Fila de pills. Si está agotado, solo el pill "Agotado" (no tiene
        // sentido mostrar oferta/descuento de algo que ya no se puede comprar).
        var pillsRow;
        if (soldOut) {
          pillsRow = '<div class="hsc-item__pills"><span class="hsc-item__soldout">' + esc(STR.soldOut || 'Agotado') + '</span></div>';
        } else {
          pillsRow = (preorderPill || salePill || discountLabel)
            ? '<div class="hsc-item__pills">' + preorderPill + salePill + discountLabel + '</div>'
            : '';
        }

        // Footer (cantidad + total) solo si la línea está disponible.
        var footerHtml = soldOut ? '' :
            '<div class="hsc-item__footer">'
          +   '<div class="hsc-qty" data-key="' + esc(item.key) + '">'
          +     '<button type="button" class="hsc-qty__btn hsc-qty__btn--minus" aria-label="' + esc(STR.reduceQty || 'Reducir cantidad') + '">&#8722;</button>'
          +     '<span class="hsc-qty__num">' + item.quantity + '</span>'
          +     '<button type="button" class="hsc-qty__btn hsc-qty__btn--plus" aria-label="' + esc(STR.increaseQty || 'Aumentar cantidad') + '">&#43;</button>'
          +   '</div>'
          +   totalHtml
          + '</div>';

        return '<div class="hsc-item' + (soldOut ? ' hsc-item--soldout' : '') + '" data-key="' + esc(item.key) + '">'
          + '<a href="' + esc(item.url) + '" class="hsc-item__img">' + imgHtml + '</a>'
          + '<div class="hsc-item__body">'
          +   '<a href="' + esc(item.url) + '" class="hsc-item__title">' + esc(item.product_title) + '</a>'
          +   '<button type="button" class="hsc-item__remove" data-remove="' + esc(item.key) + '" aria-label="' + esc(STR.remove || 'Eliminar') + '">'
          +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'
          +       '<polyline points="3 6 5 6 21 6"/>'
          +       '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>'
          +       '<path d="M10 11v6"/><path d="M14 11v6"/>'
          +       '<path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>'
          +     '</svg>'
          +   '</button>'
          +   variantHtml
          +   pillsRow
          +   savingPill
          +   footerHtml
          + '</div>'
          + '</div>';
      }).join('');

      // Fantasmas (agotados que Shopify ya quitó del carrito) al final.
      html += ghosts.map(renderGhostHtml).join('');

      itemsEl.innerHTML = html;
      bindItemEvents();
    }

    // HTML de un item "fantasma": agotado y ya ausente del carrito real.
    // Solo imagen + título + pill Agotado + botón de eliminar (sin precio
    // ni controles de cantidad). Se elimina solo del snapshot local.
    function renderGhostHtml(g) {
      var imgSrc  = g.image ? resizeImg(g.image, 300) : '';
      var imgHtml = imgSrc
        ? '<img src="' + esc(imgSrc) + '" alt="' + esc(g.title) + '" loading="lazy" decoding="async">'
        : '';
      var url = g.url || '#';
      var variantHtml = (g.variant_title && g.variant_title !== 'Default Title')
        ? '<div class="hsc-item__variant">' + esc(g.variant_title) + '</div>' : '';
      var vid = esc(String(g.variant_id));

      return '<div class="hsc-item hsc-item--soldout" data-ghost="' + vid + '">'
        + '<a href="' + esc(url) + '" class="hsc-item__img">' + imgHtml + '</a>'
        + '<div class="hsc-item__body">'
        +   '<a href="' + esc(url) + '" class="hsc-item__title">' + esc(g.title) + '</a>'
        +   '<button type="button" class="hsc-item__remove" data-remove-ghost="' + vid + '" aria-label="' + esc(STR.remove || 'Eliminar') + '">'
        +     TRASH_SVG
        +   '</button>'
        +   variantHtml
        +   '<div class="hsc-item__pills"><span class="hsc-item__soldout">' + esc(STR.soldOut || 'Agotado') + '</span></div>'
        + '</div>'
        + '</div>';
    }

    // Elimina una línea real: limpia el snapshot (para que NO reaparezca
    // como fantasma) y pide a Shopify quitarla (quantity 0).
    function removeLine(key) {
      removeFromSeen(keyToVariant[key]);
      markItemLoading(key, true);
      changeQty(key, 0);
    }

    // Elimina un fantasma: solo existe en el snapshot local. Lo quitamos y
    // re-renderizamos con el último carrito conocido (sin volver a pedir red).
    function removeGhost(variantId) {
      removeFromSeen(variantId);
      if (lastCart) renderCart(lastCart);
    }

    // ── Bind item-level events ────────────────────────────────────────
    function bindItemEvents() {
      itemsEl.querySelectorAll('[data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeLine(btn.dataset.remove);
        });
      });

      itemsEl.querySelectorAll('[data-remove-ghost]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeGhost(btn.dataset.removeGhost);
        });
      });

      itemsEl.querySelectorAll('.hsc-qty').forEach(function (qtyEl) {
        var key    = qtyEl.dataset.key;
        var numEl  = qtyEl.querySelector('.hsc-qty__num');
        var minus  = qtyEl.querySelector('.hsc-qty__btn--minus');
        var plus   = qtyEl.querySelector('.hsc-qty__btn--plus');

        minus.addEventListener('click', function () {
          var current = parseInt(numEl.textContent, 10) || 1;
          var next    = Math.max(0, current - 1);
          // Bajar a 0 equivale a eliminar: limpiar también el snapshot.
          if (next === 0) { removeLine(key); return; }
          numEl.textContent = next;
          markItemLoading(key, true);
          changeQty(key, next);
        });

        plus.addEventListener('click', function () {
          var current = parseInt(numEl.textContent, 10) || 1;
          var next    = current + 1;
          numEl.textContent = next;
          markItemLoading(key, true);
          changeQty(key, next);
        });
      });
    }

    function markItemLoading(key, state) {
      var el = itemsEl && itemsEl.querySelector('[data-key="' + key + '"]');
      if (el) el.classList.toggle('is-loading', state);
    }

    // ── Change quantity ──────────────────────────────────────────────
    var cartChangeUrl = (window.theme && window.theme.routes && window.theme.routes.cartChange)
      || '/cart/change.js';

    function changeQty(key, qty) {
      fetch(cartChangeUrl, {
        method:      'POST',
        credentials: 'same-origin',
        headers:     { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:        JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cartcustom:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('tierpdp:cart:updated'));
      })
      .catch(function () {
        hideSavings();
        fetchCart().then(renderCart);
      });
    }

    // ── Upsells ──────────────────────────────────────────────────────
    var lastUpsellPid = null;
    // Colección semilla cuando el carrito está vacío (no hay producto base
    // para /recommendations). Es la misma que usa el estado vacío / el 404.
    var FALLBACK_COLLECTION = 'novedades-7';

    // A/B Intelligems: el grupo de tratamiento apaga el widget con
    //   #cart-upsells { --hsc-upsells-ab: off; display: none !important; }
    // Al leer la variable evitamos además el fetch de /recommendations en el
    // grupo apagado. Sin CSS de Intelligems la variable vale 'on' (control).
    function upsellsEnabled() {
      if (!upsellsEl) return false;
      var flag = window.getComputedStyle(upsellsEl)
        .getPropertyValue('--hsc-upsells-ab').trim();
      return flag !== 'off';
    }

    function loadUpsells(cart) {
      if (!upsellsEl) return;
      if (!upsellsEnabled()) { upsellsEl.hidden = true; return; }

      var items = (cart && cart.items) || [];

      // Carrito vacío: sin producto semilla para /recommendations, mostramos
      // productos de una colección de respaldo (novedades) para que el widget
      // "Tal vez te interese" siga visible.
      if (items.length === 0) {
        if (lastUpsellPid === '__fallback__') return; // ya cargado
        lastUpsellPid = '__fallback__';
        fetch(ROOT + '/collections/' + FALLBACK_COLLECTION + '/products.json?limit=12', {
          credentials: 'same-origin'
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = ((data && data.products) || []).map(normalizeCollectionProduct);
          renderUpsells(prods, []);
        })
        .catch(function () { upsellsEl.hidden = true; });
        return;
      }

      var pid = items[0].product_id;
      if (pid === lastUpsellPid) return; // evita refetch si no cambió el base
      lastUpsellPid = pid;

      var inCart = items.map(function (i) { return i.product_id; });

      fetch(ROOT + '/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', {
        credentials: 'same-origin'
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = ((data && data.products) || []).map(normalizeRecommendation);
        renderUpsells(prods, inCart);
      })
      .catch(function () { upsellsEl.hidden = true; });
    }

    // Normaliza un producto de /recommendations/products.json:
    // featured_image/images[] como strings (URLs) y price en centavos.
    function normalizeRecommendation(p) {
      return {
        id:         p.id,
        url:        p.url || '/products/' + p.handle,
        title:      p.title,
        image:      p.featured_image || (p.images && p.images[0]) || '',
        priceCents: p.price || (p.variants && p.variants[0] && p.variants[0].price) || 0,
        available:  p.available
      };
    }

    // Normaliza un producto de /collections/<handle>/products.json:
    // images[] como objetos con .src y price como string decimal (unidades
    // mayores, hay que pasarlo a centavos).
    function normalizeCollectionProduct(p) {
      var firstImg = p.images && p.images[0];
      var img = (firstImg && (firstImg.src || firstImg)) || '';
      var priceStr = (p.variants && p.variants[0] && p.variants[0].price) || '0';
      return {
        id:         p.id,
        url:        '/products/' + p.handle,
        title:      p.title,
        image:      img,
        priceCents: Math.round(parseFloat(priceStr) * 100),
        available:  (p.variants || []).some(function (v) { return v.available; })
      };
    }

    // Construye y muestra el carrusel a partir de productos ya normalizados.
    function renderUpsells(prods, inCartIds) {
      prods = (prods || []).filter(function (p) {
        return inCartIds.indexOf(p.id) === -1 && p.available && p.image;
      }).slice(0, 8);

      if (prods.length < 2) { upsellsEl.hidden = true; return; }

      var cardsHtml = prods.map(function (p) {
        var img = resizeImg(p.image, 300);
        return '<a href="' + esc(p.url) + '" class="hsc-upsell-card">'
          + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">' : '')
          + '<div class="hsc-upsell-card__body">'
          +   '<div class="hsc-upsell-card__title">' + esc(p.title) + '</div>'
          +   '<div class="hsc-upsell-card__price">' + formatMoney(p.priceCents) + '</div>'
          + '</div>'
          + '</a>';
      }).join('');

      var chevronPrev = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
      var chevronNext = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';

      upsellsEl.innerHTML = '<h4 class="hsc-upsells__heading">' + esc(STR.upsellsHeading || 'Tal vez te interese') + '</h4>'
        + '<div class="hsc-upsells__carousel">'
        +   '<button type="button" class="hsc-upsells__nav hsc-upsells__nav--prev" aria-label="' + esc(STR.navPrev || 'Anterior') + '">' + chevronPrev + '</button>'
        +   '<div class="hsc-upsells__grid">' + cardsHtml + '</div>'
        +   '<button type="button" class="hsc-upsells__nav hsc-upsells__nav--next" aria-label="' + esc(STR.navNext || 'Siguiente') + '">' + chevronNext + '</button>'
        + '</div>';
      upsellsEl.hidden = false;
      bindUpsellNav();
    }

    // Flechas de navegación del carrusel de upsells (desktop).
    function bindUpsellNav() {
      var grid = upsellsEl.querySelector('.hsc-upsells__grid');
      var prev = upsellsEl.querySelector('.hsc-upsells__nav--prev');
      var next = upsellsEl.querySelector('.hsc-upsells__nav--next');
      if (!grid) return;

      function step(dir) {
        var card = grid.querySelector('.hsc-upsell-card');
        var amount = card ? (card.offsetWidth + 8) * 2 : grid.clientWidth;
        grid.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      function syncNav() {
        var max = grid.scrollWidth - grid.clientWidth - 1;
        if (prev) prev.disabled = grid.scrollLeft <= 0;
        if (next) next.disabled = grid.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      grid.addEventListener('scroll', syncNav);
      syncNav();

      // Tracking de clic en tarjeta (A/B Intelligems del widget).
      grid.addEventListener('click', function (e) {
        var card = e.target.closest && e.target.closest('.hsc-upsell-card');
        if (!card) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event:   'cart_drawer_upsell_clicked',
          product: card.getAttribute('href') || ''
        });
      });
    }

    // ── Cart note save (debounced) ────────────────────────────────────
    if (noteEl) {
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch(ROOT + '/cart/update.js', {
            method:      'POST',
            credentials: 'same-origin',
            headers:     { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body:        JSON.stringify({ note: noteEl.value })
          }).catch(function () {});
        }, 600);
      });
    }

    // ── Full cart render ─────────────────────────────────────────────
    function renderCart(cart) {
      lastCart = cart;
      updateBubble(cart.item_count);

      // Candidatos a fantasma (variantes recordadas que ya no están).
      var ghostCandidates = syncSeenAndGetGhosts(cart);

      // Cargar info (tags/compare_at/stock) de items del carrito + fantasmas.
      var handles = {};
      (cart.items || []).forEach(function (it) { if (it.handle) handles[it.handle] = true; });
      ghostCandidates.forEach(function (g) { if (g.handle) handles[g.handle] = true; });

      Promise.all(Object.keys(handles).map(fetchProductInfo)).then(function () {
        // Solo son fantasmas reales los que siguen SIN stock. Los que
        // volvieron a estar disponibles (o salieron por otra razón) se
        // limpian del snapshot para no mostrarlos indefinidamente.
        var seen = loadSeen();
        var changed = false;
        var ghosts = [];
        ghostCandidates.forEach(function (g) {
          var info = productInfoCache[g.handle];
          var v = info && info.variants[g.variant_id];
          if (v && v.available === false) {
            ghosts.push(g);
          } else {
            if (seen[g.variant_id]) { delete seen[g.variant_id]; changed = true; }
          }
        });
        if (changed) saveSeen(seen);
        renderCartContent(cart, ghosts);
      });
    }

    function renderCartContent(cart, ghosts) {
      renderItems(cart, ghosts);
      // Total, tier y upsells solo aplican si hay algo comprable; si el único
      // producto del carrito está agotado, se muestra el item pero no el footer.
      var hasPurchasable = cart.items.some(function (it) { return !isSoldOut(it); });
      if (hasPurchasable) {
        // Fila "Total": label con cantidad de artículos + precio final.
        if (totalLabelEl) {
          var n = cart.item_count;
          var totalTpl = (n === 1)
            ? (STR.totalOne  || 'Total ([count] artículo)')
            : (STR.totalOther || 'Total ([count] artículos)');
          totalLabelEl.textContent = totalTpl.replace('[count]', n);
        }
        if (totalValueEl) totalValueEl.textContent = formatMoney(cart.total_price);

        // Desglose del descuento en dos conceptos separados:
        //  • "Valor del pedido": precio de lista de cada línea. Para productos
        //    en promo (tag "sale") es el compare_at por unidad; si no, el
        //    original_line_price (precio de la variante antes del cupón).
        //  • "Promo": rebaja de los productos en "sale" = lista - precio de
        //    venta de la variante (compare_at - original_price). Es el ahorro
        //    ya incorporado en el precio del producto, sin cupón.
        //  • "Cupón": descuento del código (WOW) aplicado encima =
        //    original_line_price - final_line_price (lo que Shopify reporta
        //    como descuento de carrito/línea en cart.js).
        // Se cumple: orderValue - promo - cupon = cart.total_price.
        var orderValue   = 0; // suma de precios de lista
        var sellingValue = 0; // suma de precios de venta (variante, pre-cupón)
        cart.items.forEach(function (item) {
          var compareUnit = saleCompareUnit(item);
          var listRef = compareUnit > 0 ? compareUnit * item.quantity : item.original_line_price;
          orderValue   += listRef;
          sellingValue += item.original_line_price;
        });

        var promoDiscount  = orderValue - sellingValue;        // rebaja por "sale"
        var couponDiscount = sellingValue - cart.total_price;  // descuento del cupón
        var hasPromo   = promoDiscount  > 0;
        var hasCoupon  = couponDiscount > 0;
        var hasDiscount = hasPromo || hasCoupon;

        if (breakdownSubEl) breakdownSubEl.textContent = formatMoney(orderValue);
        if (promoRowEl && promoValueEl) {
          if (hasPromo) {
            promoValueEl.textContent = '-' + formatMoney(promoDiscount);
            promoRowEl.hidden = false;
          } else {
            promoRowEl.hidden = true;
          }
        }
        if (couponRowEl && couponValueEl) {
          if (hasCoupon) {
            couponValueEl.textContent = '-' + formatMoney(couponDiscount);
            couponRowEl.hidden = false;
          } else {
            couponRowEl.hidden = true;
          }
        }
        // Sin descuento → ocultar flecha/desglose (no hay nada que desglosar).
        if (totalToggleEl) totalToggleEl.classList.toggle('hsc-total__trigger--has-breakdown', hasDiscount);
        if (!hasDiscount) collapseBreakdown();

        renderSavings(orderValue, cart.total_price);
      }

      // La barra de progreso (tiers) y los upsells se muestran SIEMPRE,
      // incluso con el carrito vacío o solo con productos agotados.
      renderTier(cart);
      loadUpsells(cart);
    }

    // ── Open / Close ─────────────────────────────────────────────────
    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      // Limpiar cualquier transform/transición inline que dejara un arrastre.
      if (panel) { panel.style.transition = ''; panel.style.transform = ''; }
      drawer.classList.add('hsc-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hsc-drawer-active');
      document.documentElement.classList.add('hsc-drawer-active');

      fetchCart().then(renderCart).catch(hideSavings);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'cart_drawer_opened', variant: 'B' });
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('hsc-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hsc-drawer-active');
      document.documentElement.classList.remove('hsc-drawer-active');
      collapseBreakdown(); // reabrir siempre colapsado
    }

    // ── Cart icon click ──────────────────────────────────────────────
    // capture:true + stopPropagation evita que otros listeners en
    // document bubble también procesen el mismo click.
    document.querySelectorAll('.js-drawer-open-cart').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openDrawer();
      }, true); // capture phase
    });

    // ── Close triggers ───────────────────────────────────────────────
    if (overlay) overlay.addEventListener('click', closeDrawer);

    drawer.querySelectorAll('[data-hsc-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    // ── Swipe-to-dismiss (bottom-sheet en mobile) ────────────────────
    // Nested scrolling manual: mientras el contenido aún puede scrollear
    // hacia arriba (scrollTop > 0) el gesto se comporta como scroll normal;
    // solo cuando el contenido está en su tope (scrollTop === 0) y el dedo
    // arrastra hacia abajo, el panel sigue al dedo con transform translateY().
    (function () {
      if (!panel) return;

      // Solo aplica en el layout de bottom-sheet (≤749px). Arriba de eso el
      // panel entra lateralmente (translateX) y el gesto vertical no aplica.
      var mq = window.matchMedia('(max-width: 749px)');

      var startY = 0, startX = 0;       // origen del gesto
      var lastY = 0, lastT = 0;         // última muestra (para velocidad)
      var dragStartY = 0;               // Y en el instante que empieza el arrastre del panel
      var velocity = 0;                 // px/ms (positivo = hacia abajo)
      var currentTranslate = 0;         // translateY aplicado actualmente
      var active = false;               // hay un touch en curso
      var decided = false;              // ya se resolvió la dirección del gesto
      var dragging = false;             // el panel está siguiendo al dedo

      function panelHeight() {
        return panel.offsetHeight || window.innerHeight;
      }

      function onStart(e) {
        if (!isOpen || !mq.matches || e.touches.length !== 1) return;
        active = true;
        decided = false;
        dragging = false;
        velocity = 0;
        currentTranslate = 0;
        var t = e.touches[0];
        startY = lastY = t.clientY;
        startX = t.clientX;
        lastT = Date.now();
      }

      function onMove(e) {
        if (!active || !mq.matches) return;
        var t  = e.touches[0];
        var dy = t.clientY - startY;
        var dx = t.clientX - startX;

        if (!decided) {
          // Umbral mínimo para evitar falsos positivos en taps.
          if (Math.abs(dy) < 6 && Math.abs(dx) < 6) return;
          decided = true;
          // El panel solo se arrastra si el gesto es predominantemente
          // vertical, hacia abajo, y el contenido ya está en su tope superior.
          var atTop = !bodyEl || bodyEl.scrollTop <= 0;
          if (dy > 0 && Math.abs(dy) > Math.abs(dx) && atTop) {
            dragging = true;
            dragStartY = t.clientY;
            panel.style.transition = 'none'; // seguir al dedo sin lag
          }
        }

        // Velocidad instantánea (para detectar flick rápido al soltar).
        var now = Date.now();
        var dt  = now - lastT;
        if (dt > 0) velocity = (t.clientY - lastY) / dt;
        lastY = t.clientY;
        lastT = now;

        if (dragging) {
          var move = t.clientY - dragStartY;
          if (move < 0) move = 0;        // nunca por encima de la posición abierta
          currentTranslate = move;
          panel.style.transform = 'translateY(' + move + 'px)';
          // Evita el scroll del navegador y el pull-to-refresh durante el arrastre.
          e.preventDefault();
        }
      }

      function onEnd() {
        if (!active) return;
        active = false;
        if (!dragging) return;
        dragging = false;

        panel.style.transition = ''; // restaurar la transición del CSS

        // Cerrar si se arrastró más del 30% del alto o fue un flick rápido.
        var shouldClose = currentTranslate > panelHeight() * 0.3 || velocity > 0.5;
        // En ambos casos quitamos el transform inline: al cerrar, la clase
        // --open desaparece (=> translateY(100%)); al volver, queda translateY(0).
        panel.style.transform = '';
        if (shouldClose) closeDrawer();

        currentTranslate = 0;
        velocity = 0;
      }

      panel.addEventListener('touchstart', onStart, { passive: true });
      panel.addEventListener('touchmove',  onMove,  { passive: false });
      panel.addEventListener('touchend',   onEnd);
      panel.addEventListener('touchcancel', onEnd);
    })();

    // ── Toggle del desglose de Total (ligado una sola vez) ───────────
    if (totalToggleEl) totalToggleEl.addEventListener('click', toggleBreakdown);

    // ── ajaxProduct:added → open drawer ─────────────────────────────
    document.addEventListener('ajaxProduct:added', function () {
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      }).catch(function () { hideSavings(); openDrawer(); });
    });

    // ── Public events ────────────────────────────────────────────────
    document.addEventListener('cart:open',  openDrawer);
    document.addEventListener('cart:close', closeDrawer);

    // ── Checkout tracking ────────────────────────────────────────────
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cart_drawer_checkout_clicked', variant: 'B' });
      });
    }

    // ── Init bubble count from page load ────────────────────────────
    fetchCart().then(function (cart) {
      updateBubble(cart.item_count);
    }).catch(function () {});

  } // fin initDrawer

  // Arrancar si la variante ya es 'B'; si se resuelve tarde (Intelligems),
  // el evento 'hs:cart-variant' que emite theme.liquid dispara el init.
  maybeInit();
  document.addEventListener('hs:cart-variant', maybeInit);
})();
